module.exports = __webpack_public_path__ + "static/img/kjdy10.47d06cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy10.png
// module id = 325
// module chunks = 0